import { useMutation, useQueryClient } from "react-query";
import immer from "immer";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useUpdateTranslation = (projectId, version) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();
  const queryKey = [
    "project",
    projectId.toString(),
    "version",
    version?.toString(),
    "keys",
  ];

  return useMutation(
    async ({ text, translationId }) => {
      await fetchContext.authAxios.put(
        `/projects/${projectId}/translations/${translationId}`,
        {
          translation: text,
        }
      );
    },
    {
      onMutate: async ({ text, keyId, translationId }) => {
        await queryClient.cancelQueries(queryKey);
        queryClient
          .getQueryCache()
          .findAll(queryKey)
          .forEach(({ queryKey }) => {
            const previousKeys = queryClient.getQueryData(queryKey);
            const newKeys = immer(previousKeys, (draft) => {
              // eslint-disable-next-line no-restricted-syntax
              for (const k of draft) {
                if (k.id === keyId) {
                  // eslint-disable-next-line no-restricted-syntax
                  for (const t of k.translations) {
                    if (t.id === translationId) {
                      t.translation = text;
                    }
                  }
                  k.modifiedAt = new Date().toISOString();
                }
              }
            });
            queryClient.setQueryData(queryKey, newKeys);
          });
      },
      onError: (err, newTodo, context) => {
        queryClient.invalidateQueries(queryKey, { exact: false });
      },
    }
  );
};
